<div class="jumbotron jumbotron-headline">
  <div class="container text-center">
    <h1><ng-content></ng-content></h1>
    <p class="lead" *ngIf="subTitle">
      <ng-container *ngTemplateOutlet="subTitle"></ng-container>
    </p>
  </div>
</div>
